import * as React from 'react';
import { identity } from 'lodash';
export var LinkPathTransformerContext = React.createContext(identity);
export var LinkPathTransformerProvider = LinkPathTransformerContext.Provider;